import { FormGroup } from "@angular/forms";

export const IntegrationOrganizationColumns = {
	model: [
		{
			label: 'Integration Client Id',
			key: 'integrationClientId'
		},
		{
			label: 'Class Organization Id',
			key: 'classOrganizationId'
		},
		{
			label: 'Class Organization Name',
			key: 'classOrganizationName'
		},
		{
			label: 'Tenant Configuration Id',
			key: 'tenantConfigurationId',
			isLink: {
				isExternalIntegration: true,
				enable: true,
				customUrl: 'tenant-configuration',
				label: 'Tenant',
				icon: 'pi pi-spin pi-cog',
				width: '450px',
				displayFields: ['name', 'url','credentials.username']
			}
		}
	],
	formBuilderConfig: {
		integrationClientId: {
			DataType: 'String',
			DisplayText: 'Integration Client Id',
			Name: 'integrationClientId',
		},
		classOrganization: {
			DataType: 'Selector',
			DisplayText: 'Class Organization',
			Name: 'classOrganization',
			UIControl: 'Autocomplete',
			UIOptions: {
				FilterName: 'Name',
				Url: '',
				Mapper: {
					id: 'classOrganizationId',
					name: 'classOrganizationName'
				}
			},
			UIEvents: {
				onSelect: ($event: any, formGroup: any, model?: any) => {
					if ($event) {
						formGroup.get('classOrganizationName')?.setValue($event.name);
						formGroup.get('classOrganizationId')?.setValue($event.id);
					}
				}
			}
		},
		classOrganizationName: {
			DataType: 'String',
			DisplayText: 'Class Organization Name',
			Name: 'classOrganizationName',
			hidden: true
		},
		tenantConfiguration: {
			DataType: 'Selector',
			DisplayText: 'Tenant Configuration Id',
			Name: 'tenantConfiguration',
			UIControl: 'Autocomplete',
			required: false,
			UIOptions: {
				FilterName: 'Name',
				Url: '',
				Mapper: {
					id: 'tenantConfigurationId',
					name: 'tenantConfigurationName'
				}
			},
			UIEvents: {
				onClear: ($event: any, formGroup: any, model?: any) => {
					formGroup.get('tenantConfigurationId')?.setValue(null);
					formGroup.get('tenantConfigurationName')?.setValue(null);
				},
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					if ($event.id) {
						formGroup.get('tenantConfigurationId')?.setValue($event.id);
						formGroup.get('tenantConfigurationName')?.setValue($event.name);
					}
				},
				onSelect: ($event: any, formGroup: any, model?: any) => {
					if ($event) {
						formGroup.get('tenantConfigurationId')?.setValue($event.id);
						formGroup.get('tenantConfigurationName')?.setValue($event.name);
					}
				}
			}
		},
		tenantConfigurationId: {
			DataType: 'String',
			DisplayText: 'Tenant Configuration Id',
			Name: 'tenantConfigurationId',
			hidden: true,
			required: false,
		},
		classOrganizationId: {
			DataType: 'String',
			DisplayText: 'Class Organization Id',
			Name: 'classOrganizationId',
			hidden: true
		},
		integrationId: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'integrationId',
			hidden: true,
			required: false
		},
	}
}
